<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()">
  <app-contactperson-navigation></app-contactperson-navigation>

  <div [@routeAnimations]="routeAnimationState()">
    <router-outlet></router-outlet>
  </div>
</agr-page-detail>
